<template>
  <div class="container-fluid">
    <div class="no-print">
      <DetailTop v-if="detailTop" :detailTop="detailTop" />

      <div class="d-flex flex-between my-3">
        <h4 class="text-uppercase mb-0">data rawat jalan</h4>
      </div>
      <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
        <div class="col-md-7 pr-1" v-if="detailLeftTop">
          <DetailLeft :detailLeftTop="detailLeftTop" />
        </div>
        <div class="col-md-5 pl-1" v-if="detailRightTop">
          <DetailRight :detailRightTop="detailRightTop" />
        </div>
      </div>
    </div>
    <div class="row mb-3 no-print">
      <div class="col-md-12">
        <div class="d-flex flex-between my-3">
          <h5 class="mb-2">Resep Obat / Alkes</h5>
          <div class="d-flex">
            <router-link
              to="#"
              class="btn btn-lg btn-with-icon-left btn-primary mr-2"
              v-if="obat.length"
            >
              <i class="material-symbols-outlined">print</i>
              CETAK RESEP OBAT
            </router-link>
          </div>
        </div>
        <table class="responsive" v-if="obat.length">
          <thead>
            <th>KODE / NAMA BARANG / JENIS OBAT / GOLONGAN OBAT</th>
            <!-- <th>LOKASI</th> -->
            <th>HARGA/SATUAN</th>
            <th>JUMLAH</th>
            <th>EMBALASE</th>
            <th>TUSLAH</th>
            <th>ATURAN PAKAI</th>
            <th>SUB TOTAL</th>
          </thead>
          <tbody>
            <tr
              v-for="item in obat"
              v-bind:key="item.id + item.kode + Math.random(1024)"
            >
              <td>
                {{ item.kode }} / {{ item.nama }} / {{ item.jenis }} /
                {{ item.golongan_obat }}
              </td>
              <!-- <td>{{ item.lokasi }}</td> -->
              <td>{{ item.formatted_harga }}</td>
              <td>{{ item.jumlah }}</td>
              <td>{{ item.formatted_embalase }}</td>
              <td>{{ item.formatted_tuslah }}</td>
              <td>{{ item.catatan_dokter }}</td>
              <td>{{ item.formatted_sub_total }}</td>
            </tr>
          </tbody>
        </table>
        <EmptyState v-else :data="emptyObat" />
      </div>
    </div>
    <div class="only-print">
      <div class="row">
        <div
          class="col-md-4 px-0"
          style=""
          v-for="item in obat"
          v-bind:key="item.id + item.kode + Math.random(1024)"
        >
          <div class="card" style="height: 100%">
            <div class="card-body">
              <p class="mb-1">Nama: {{ detailTop.title }}</p>
              <small
                >{{ item.kode }}/ {{ item.jenis }} /
                {{ item.golongan_obat }}</small
              >
              <h5>{{ item.nama }}</h5>
              <span>{{ item.catatan_dokter }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import EmptyState from "@/components/EmptyState.vue";
// import { HTTP } from "@/config.js";
import { data, longText, tabs } from "@/data/RalanDetail.js";
import { setPatientIntro } from "@/data/helper.js";

export default {
  name: "RalanDetail",
  components: {
    DetailTop,
    DetailLeft,
    DetailRight,
    EmptyState,
  },
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      classes: {
        DIBATALKAN: "danger",
        DIJADWALKAN: "primary",
        "SEDANG DIPERIKSA": "secondary",
        SELESAI: "success",
        "MENUNGGU PEMBAYARAN": "warning",
        "SELESAI DIPERIKSA": "info",
      },
      test: "hahaha",
      id_ralan: "",
      status: "",
      data: data,
      longText: longText,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      detailBottom: null,
      detailApproval: null,
      dataPetugasLeft: null,
      dataPetugasRight: null,
      dataOphthalmic: null,
      dataTabelOphthalmic: null,
      dataDokterLeft: null,
      dataDokterRight: null,
      tabs: tabs,
      emptyPtg: {
        img: "/img/nurse.svg",
        title: "Belum Ada Pemeriksaan Perawat",
        content:
          "Isi data pemeriksaan perawat dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/ralan/form-petugas/" + this.$route.params.id,
        label: "Input Pemeriksaan Perawat",
      },
      emptyOph: {
        img: "/img/oph.svg",
        title: "Belum ada pemeriksaan ophthalmic",
        content:
          "Isi data pemeriksaan ophthalmic dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/ralan/form-ophthalmic/" + this.$route.params.id,
        label: "Input Pemeriksaan Ophthalmic",
      },
      emptyDok: {
        img: "/img/doctor.svg",
        title: "Belum ada pemeriksaan dokter",
        content:
          "Isi data pemeriksaan dokter dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/ralan/form-dokter/" + this.$route.params.id,
        label: "Input Pemeriksaan Dokter",
      },
      emptyTindakan: {
        img: "/img/nurse.svg",
        title: "Belum ada data tindakan",
        content: "Isi data tindakan dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyLab: {
        img: "/img/lab.svg",
        title: "Belum ada data",
        content:
          "Isi data pemeriksaan lab dengan mengeklik tombol Ubah Data Tindakan",
        size: "small",
        link: "",
        label: "",
      },
      emptyObat: {
        img: "/img/med.svg",
        title: "Belum ada resep obat",
        content: "Input resep obat dengan mengeklik tombol Ubah Resep Obat",
        size: "small",
        link: "",
        label: "",
      },
      emptyOptik: {
        img: "/img/opt.svg",
        title: "Belum ada resep optik",
        content: "Input resep optik dengan mengeklik tombol Ubah Resep Optik",
        size: "small",
        link: "",
        label: "",
      },
      metodeBayar: ["Umum", "BPJS", "Asuransi Lain"],
      resiko: [
        "Rendah",
        "Rendah",
        "Rendah",
        "Rendah",
        "Sedang",
        "Sedang",
        "Sedang",
        "Sedang",
        "Tinggi",
        "Tinggi",
        "Tinggi",
      ],
      tabActive: "pemeriksaan",
      formSet: {
        id_petugas: "",
        id_petugas_lab: "",
        id_dokter: "",
        lab_type: "",
      },
      doc: [],
      nrs: [],
      both: [],
      lab: [],
      obat: [],
      optik: [],
      resepOptik: null,
    };
  },
  methods: {
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/${this.$route.params.id}?darurat=0`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          // this.rows = result.data;
          //console.log(this.rows);
          let dataPasien = result.data.pasien;
          let ralan = result.data;
          if (ralan.asal_rujukan) {
            let faskes = await this.$store.state.HTTP.get(
              `faskes/${ralan.asal_rujukan}`
            );
            if (faskes.status == "200") {
              ralan.asal_rujukan_formatted = faskes.data.nama;
            }
          }
          this.status = ralan.status;
          this.$set(this.data, "actionBtn", [
            {
              type: "status",
              className: `badge-${this.classes[this.status]}`,
              label: this.status,
            },
          ]);
          this.id_ralan = ralan.id;
          //console.log(ralan);
          this.detailTop = setPatientIntro(dataPasien);
          //console.log(this.detailTop);
          this.detailLeftTop = [
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "No. Registrasi   |    No. Rawat",
                  content: ralan.formatted_no_reg_rawat,
                  icon: "confirmation_number",
                },
                {
                  label: "Tanggal/Waktu Periksa",
                  content: ralan.formatted_tgl_jam_periksa,
                  icon: "access_time",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Unit",
                  content: ralan.unit.nama,
                  icon: "label_outline",
                },
                {
                  label: "Jenis Periksa",
                  content: ralan.jen_periksa,
                  icon: "filter_center_focus",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Dokter yang Dituju",
                  content: ralan.dokter.formatted_nama,
                  icon: "person_pin",
                },
                {
                  label: "Status",
                  content: ralan.status,
                  icon: "check_circle",
                },
              ],
            },
            {
              key: String(Math.random(1023)),
              colnum: 2,
              columns: [
                {
                  label: "Tindak Lanjut Penanganan",
                  content: ralan.tindak_lanjut_pelayanan,
                  icon: "ward",
                },
                {
                  label: "Tujuan Rujukan",
                  content: ralan.merujuk
                    ? ralan.tujuan_rujukan_formatted
                    : "Tidak Ada",
                  icon: "home_health",
                },
              ],
            },
          ];

          this.detailRightTop = [
            {
              label: "Metode Pembayaran",
              content: this.metodeBayar[parseInt(ralan.id_asuransi) - 1],
              icon: "payment",
            },
            {
              label: `Nomor Peserta ${
                this.metodeBayar[parseInt(ralan.id_asuransi) - 1]
              }`,
              content: ralan.no_peserta || "-",
              icon: "contacts",
            },
            {
              label: "Asal Rujukan",
              content: ralan.dirujuk
                ? ralan.asal_rujukan_formatted
                : "Tanpa Rujukan",
              icon: "rotate_right",
            },
          ];
          this.fetchObat(ralan.no_rawat);
          this.print();
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    fetchObat: async function(no_rawat) {
      try {
        let url = "";
        if (this.$route.query.ranap_obat && this.$route.query.tgl_obat) {
          url = `ranap/resep/obat?no_rawat=${no_rawat}&tgl_periksa=${this.$route.query.tgl_obat}`;
        } else {
          url = `ralan/resep/obat?no_rawat=${no_rawat}`;
        }
        let result = await this.$store.state.HTTP.get(url);
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_obat = item.id;
            item.id = item.obat.id;
            item.kode = item.obat.kode;
            item.nama = item.obat.nama;
            item.jenis = item.obat.jenis;
            item.lokasi = item.obat.lokasi;
            self.obat.push(item);
          });
          self.obat = self.obat.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchOptik: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/barang/optik?no_rawat=${no_rawat}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_optik = item.id;
            item.id = item.optik.id;
            item.kode = item.optik.kode;
            item.nama = item.optik.nama;
            item.jenis = item.optik.jenis;
            item.lokasi = item.optik.lokasi;
            self.optik.push(item);
          });
          self.optik = self.optik.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchResepOptik: async function(no_rawat) {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/resep/optik?no_rawat=${no_rawat}`
        );
        //console.log(result);
        // let self=this;
        if (result.status == "200") {
          //console.log('resep-optik');
          //console.log(result);
          //console.log('resep-optik');
          if (result.data) {
            this.resepOptik = result.data;
            //console.log(this.resepOptik);
            this.resepOptik.id_resep = this.resepOptik.id;
          }
        }
      } catch (e) {
        //console.log(e);
      }
    },
    print: async function() {
      setTimeout(function() {
        window.print();
      }, 1000);
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.displayData();
  },
};
</script>
